const Warning = () => {
  return (
    <div className="warning-mobile">
      <h2>Please use desktop to see content.</h2>
    </div>
  );
};

export default Warning;
